import {useHostName} from 'presentation/hooks';
import {useGetHealthCardQuery} from 'presentation/pages/private/health-card/queries/useGetHealthCardQuery';
import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';
import {useGetContractualTermPendingQuery} from '../../../../query/useGetContractualTermPendingQuery';
import {useOdontoTermDrawerStore} from '../../../../store/useOdontoTermDrawerStore';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {FeaturesEnum} from 'presentation/constants';

export function useOdontoTermDrawerVisibility() {
	const {isHAP} = useHostName();
	const {isEnabled: isShowLojasTorraTermEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_SHOW_LOJAS_TORRA_TERM,
	);
	const {
		beneficiary: {nuContratoC, nuContrato},
	} = useAccountDataStore(state => state.accountData);
	const isDismissed = useOdontoTermDrawerStore(state => state.isDismissed);

	const contractNumber = String(nuContratoC ?? nuContrato ?? '');
	const shouldCheckPendingTerm = !isDismissed && isHAP && isShowLojasTorraTermEnabled;

	const {data: isTermPending} = useGetContractualTermPendingQuery({
		nuContrato: contractNumber,
		enabled: shouldCheckPendingTerm,
	});

	const shouldRequestAcceptance = shouldCheckPendingTerm && Boolean(isTermPending);

	const {data: healthCardData} = useGetHealthCardQuery({enabled: shouldRequestAcceptance});

	const planName = healthCardData?.nmPlano ?? '';
	const ansRegister =
		healthCardData?.registroPlanoAnsOdonto || healthCardData?.registroAnsSemMascara || '';

	return {
		isOpen: shouldRequestAcceptance && !!healthCardData,
		contractNumber,
		planName,
		ansRegister,
	};
}
